/* eslint-disable */
import styled from 'styled-components';

export const Box = styled.div`
  align-items: center;
  background-color: ${p => p.theme.color.whiteTrue};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 60vh;
  min-width: 600px;
  padding: ${p => p.theme.spacing(12)};

  @media (${p => p.theme.mq.mobile}) {
    box-shadow: none;
    padding: ${p => p.theme.spacing(2)};
    min-width: 95%;
  }
`;

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 9999;
`;

export const Title = styled.h3`
  padding-top: 14px;
  @media (${p => p.theme.mq.mobile}) {
    max-width: 22ch;
  }
`;

export const ApplicationLink = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 110px;
  min-width: 290px;
  width: 100%;
  border-radius: 8px;
  box-shadow: ${p => p.theme.boxShadow2};
  text-align: center;
  color: ${p => p.theme.color.whiteTrue};

  &:not(:first-child) {
    margin-top: 15px;
  }

  @media (${p => p.theme.mq.desktop}) {
    height: 140px;
  }
`;

export const ApplicationLinkImage = styled.div`
    height: 100%;
    min-width: 33%;
    widht: 33%;
    background-image: url("${p => p.url}");
    background-size: cover;
    background-position: center;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
`;

export const ApplicationLinkAddressBox = styled.div`
  height: 100%;
  width: 62%;
  display: flex;

  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 20px;
`;

export const ApplicationLinkAddress = styled.span`
  color: gray;
  position: relative;
  font-size: 0.8rem;

  &:not(:first-child) {
    margin-top: 10px;
  }

  &::after {
    content: '';
    position: absolute;
    left: -15px;
    top: 6px;
    height: 10px;
    width: 10px;
    border-radius: 50%;
  }

  &:nth-child(1) {
    &::after {
      background-color: ${p => p.theme.color.teal};
    }
  }

  &:nth-child(2) {
    &::after {
      background-color: ${p => p.theme.color.orange};
    }
  }

  &:nth-child(3) {
    &::after {
      background-color: ${p => p.theme.color.yellow};
    }
  }
`;

export const ApplicationLinkStatus = styled.div`
  width: 5%;
  height: 100%;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  background-color: ${p =>
    p.status === 'ACTIVE' ||
    p.status === 'TREATING' ||
    p.status === 'READY' ||
    p.status === 'AWAITINGSIGN' ||
    p.status === 'SENT'
      ? p.theme.color.teal
      : p.status === 'WAITING'
        ? p.theme.color.orange
        : p.theme.color.red};
`;

/* eslint-enable */



// WEBPACK FOOTER //
// ./src/components/ApplicationPicker/styles.js